<template>
  <div class="Aviso">
    <headNav :activeNav="'Aviso'"></headNav>

    <div class="banner"></div>
    <div class="bigContent">
      <p class="bigTitle">「 POLÍTICA DE PRIVACIDAD 」</p>
      <div class="content">
        <p>
          El presente documento contiene la Política de Privacidad del EkeCash
          (también denominado “Aviso de Privacidad”) y se encuentra en armonía
          con la normativa vigente sobre Protección de Datos Personales (Ley N°
          29733, Ley de Protección de Datos Personales, y su Reglamento,
          aprobado por Decreto Supremo N° 003-2013-JUS). En el presente
          documento, se señalan las finalidades del tratamiento sobre la
          información que usted nos otorga, quiénes son los encargados de
          tratarla, las medidas de protección y los medios para ejercer sus
          derechos como titular de los Datos Personales, entre otros aspectos.
          Por favor lea con detenimiento este documento para entender la
          información que recolectamos sobre usted, cómo la usamos y las
          circunstancias bajo las cuales la compartiremos con terceras partes.
        </p>
        <p>
          La presente Política tiene por objeto hacer de conocimiento del
          público nuestro compromiso con la protección de sus datos personales,
          así como los lineamientos bajo los cuales realizamos el tratamiento de
          estos en ejercicio de nuestras actividades comerciales, la finalidad
          para la que lo hacemos, así como los procedimientos para que los
          titulares de los mismos puedan ejercer los derechos previstos en la
          Normativa de Protección de Datos Personales.
        </p>
        <p>
          El titular de los bancos de datos en los que se almacenarán los datos
          personales facilitados por usted es PERUCRED DIGITAL FINANCE S.A.C.
          (en adelante, “EkeCash”), identificada con RUC N° 20610129626, con
          domicilio en Calle Las Golondrinas 393, Int. 802, distrito de San
          Isidro, provincia y departamento de Lima.
        </p>
        <p>
          La existencia del banco de datos personales en el que se almacenarán
          los datos personales facilitados por usted ha sido declarada ante la
          Autoridad Nacional de Protección de Datos Personales, mediante su
          inscripción en el Registro Nacional de Protección de Datos Personales
          con la denominación “PROSPECTOS DE CLIENTES” (con código RNPDP-PJP N°
          27198), para el caso de los posibles clientes a quienes no se ha
          otorgado un crédito aún, y “CLIENTES-MIRAFLORES” (con código RNPDP-PJP
          N° &nbsp;27199) para el caso de los clientes, quienes ya han
          contratado un crédito.
        </p>
        <p>
          <strong>¿QUÉ DATOS PERSONALES USAMOS?</strong>
        </p>
        <p>
          EkeCash recabará de ti (en adelante el “Titular” o “tú”) los
          siguientes datos personales obligatorios (en lo sucesivo los “datos” o
          los “datos personales”) en tu calidad de uno de nuestros clientes y
          prospecto de clientes:
        </p>
        <p>- Datos de contacto (correo electrónico);</p>
        <p>
          - Datos de identificación (nombre, fecha de nacimiento, captura de
          imagen, identificación oficial, género asignado);
        </p>
        <p>- Datos biométricos;</p>
        <p>
          - Datos de localización y geolocalización (ubicación aproximada);
        </p>
        <p>- Datos laborales y educativos;</p>
        <p>
          - Datos de comunicación con EkeCash (solicitudes de atención al
          cliente, respuestas a aclaraciones u otras comunicaciones a través de
          mensajes SMS, correo electrónico o grabación de llamadas);
        </p>
        <p>
          - Datos de tu teléfono celular o dispositivo móvil (información del
          hardware, IMEI, dirección IP, dirección MAC, GPS ADID o identificación
          de otro dispositivo, operador móvil);
        </p>
        <p>
          - Datos de uso de tu dispositivo (lista de aplicaciones instaladas,
          datos de cuentas);
        </p>
        <p>
          - Datos de SMS (la marca de tiempo, el número de teléfono y el
          contenido del SMS);
        </p>
        <p>
          - Datos patrimoniales y financieros (ingresos o datos o documentos de
          tu empleo, grado de escolaridad, propósito o uso que se le dará al
          préstamo);
        </p>
        <p>
          - Datos que proporciones en tu solicitud de préstamo;
        </p>
        <p>
          - Datos transaccionales de las operaciones que realizas con nosotros o
          a través de nosotros, así como de las operaciones que realizas con
          transmisores de dinero, instituciones de fondos de pago electrónico,
          instituciones de financiamiento colectivo, instituciones de crédito y
          otras instituciones financieras o comercios electrónicos; y
        </p>
        <p>
          - Datos de uso de la aplicación de EkeCash y de otras aplicaciones
          (detalles de instalación, tráfico, navegación).
        </p>
        <p>
          <strong>¿USAMOS DATOS PERSONALES SENSIBLES?</strong>
        </p>
        <p>
          EkeCash no solicita directamente datos raciales o de origen étnico, de
          salud, creencias filosóficas o religiosas, afiliación sindical,
          opiniones políticas, preferencias sexuales (salvo por tu género
          asignado que se requiere para temas de prevención de lavado de
          dinero). Sin embargo, recabamos información relacionada con tus
          mensajes de texto, registro de mensajes de texto e imágenes que
          incidentalmente puede tener datos personales sensibles.
        </p>
        <p>
          <strong>¿A QUÉ PERMISOS EN TU DISPOSITIVO ACCEDE EkeCash?</strong>
        </p>
        <p>
          Nosotros podríamos combinar la información brindada por usted con
          información recolectada de otras fuentes con la finalidad de
          actualizar datos que se encuentren incompletos o sustituirlos, en base
          a consultar de fuentes de acceso público.
        </p>
        <p>
          Esta información, y la información combinada, podría ser usada para
          cualquiera de los usos y fines señalados en el presente documento.
        </p>
        <p>
          La siguiente información se recoge de forma segura y mantenemos tus
          datos seguros.
        </p>
        <p>
          Información recaudada al utilizar la aplicación y/o web
        </p>
        <p><strong>SMS</strong></p>
        <p>
          · Recopilaremos todos sus datos SMS, pero solo monitoreamos sus
          mensajes relacionados con transacciones financieras.
        </p>
        <p>
          · Para ser específicos, monitorearemos el nombre del remitente, la
          descripción y el monto de la transacción para realizar la evaluación
          del riesgo crediticio.
        </p>
        <p>
          · Lo anterior nos permite identificarte adecuadamente y verificar si
          calificas como persona a ser financiada por nosotros.
        </p>
        <p>
          · Subiremos los datos de SMS al servidor de EkeCash
          (https://api.ekecash.pe) a través de una conexión segura.
        </p>
        <p><strong>Ubicaciones</strong></p>
        <p>
          · Recopilamos y monitoreamos la información acerca de las ubicaciones
          de sus dispositivos para la evaluación del perfil del cliente y para
          evitar fraudes.
        </p>
        <p>
          · Subiremos los datos de ubicaciones al servidor de EkeCash
          (https://api.ekecash.pe).
        </p>
        <p><strong>Celular:</strong></p>
        <p>
          · Recopilamos y monitoreamos información acerca de su dispositivo,
          incluyendo nombre, modelo, región, lengua, código de identificación,
          información de hardware y software, estatus, hábitos de uso,
          identificadores únicos como IMEI y números seriales.
        </p>
        <p>
          · Dicha información nos es útil para identificar el dispositivo desde
          donde proviene la solicitud de préstamo y otras adicionales, para
          evaluar adecuadamente tu perfil y evitar fraudes.
        </p>
        <p>
          · Además, recogeremos tu lista detallada de aplicaciones instaladas
          para evaluar tu propensión al préstamo y tu situación de deuda.
        </p>
        <p>
          · Subiremos los datos de celular al servidor de EkeCash
          (https://api.ekecash.pe).
        </p>
        <p><strong>Cámara:</strong></p>
        <p>
          · Se pedirá acceso a la cámara del dispositivo móvil para que puedas
          identificarte por medio de un “selfie” y además puedas proporcionarnos
          los documentos necesarios para el proceso de solicitud y evaluación de
          tu perfil de cliente.
        </p>
        <p>
          · Subiremos los datos de cámara al servidor de EkeCash
          (https://api.ekecash.pe).
        </p>
        <p><strong>Calendario:</strong></p>
        <p>
          · Solicitaremos acceso a su calendario, para poder agendar la fecha de
          pago respectiva y los recordatorios respectivos.
        </p>
        <p>
          · De esta manera, gestionamos nuestro riesgo de crédito y evitamos
          pagos vencidos.
        </p>
        <p>
          · Subiremos los datos de calendario al servidor de EkeCash
          (https://api.ekecash.pe).
        </p>
        <p><strong>Actividad en apps:</strong></p>
        <p>
          · Necesitamos obtener la <strong>actividad en apps</strong>, incluido
          nombre del paquete, nombre de la aplicación, la hora de la primera
          instalación y la hora de actualización de la aplicación, para evaluar
          si el cliente es elegible para solicitar un préstamo.
        </p>
        <p>
          · Cargaremos esta información a nuestro servidor
          (https://api.ekecash.pe) encriptado, y se usa para identificar y
          analizar comportamiento y riesgo en múltiples préstamos para evaluar
          si un préstamo puede procesarse, lo que ayuda a prevenir el fraude.
        </p>
        <p>
          <strong>Información personal del usuario</strong>
        </p>
        <p>
          · Para realizar control de riesgo y evaluar la elegibilidad del
          usuario, necesitamos usar las informaciones personales incluido nombre
          completo, estado civil, género, fecha de nacimiento, edad, país,
          identificación oficial vigente, documento nacional de identidad (DNI),
          correo electrónico, datos académicos, dirección residencial.
        </p>
        <p>
          · Realizamos depósito bancario directamente mediante el número de
          cuenta proporcionados por los usuarios.
        </p>
        <p><strong>El cooperador</strong></p>
        <p>
          Para optimizar la atribución de nuestras campañas de marketing digital
          y comprender la fuente de instalación de nuestra aplicación,
          utilizamos un SDK que facilita la conexión con servicios de atribución
          de marketing y plataformas de publicidad digital. Estos destinatarios
          específicos incluyen, pero no se limitan a, Google (a través de sus
          servicios como Google Ads y Google Analytics) y Facebook (a través de
          sus herramientas de publicidad y medición). A través de esta
          integración, compartimos identificadores de dispositivo anonimizados o
          seudónimos (nunca información que directamente lo identifique sin
          otros datos adicionales), así como datos agregados y despersonalizados
          sobre la interacción del usuario con nuestra publicidad y la
          instalación de la aplicación. La finalidad exclusiva de esta
          transferencia es medir la efectividad de nuestras campañas
          publicitarias, atribuir la adquisición de usuarios a canales
          específicos, y optimizar nuestras estrategias de marketing digital.
          Reiteramos que ni nuestro socio de Deeplink ni nuestra propia
          aplicación acceden o utilizan información directa de las cuentas
          sociales del usuario.
        </p>
        <p>
          · En resumen, las finalidades para las que utilizaremos tus datos
          serán las siguientes:
        </p>
        <p>
          - Nosotros podríamos combinar la información brindada por usted con
          información recolectada de otras fuentes con la finalidad de
          actualizar datos que se encuentren incompletos o sustituirlos, en base
          a consultar de fuentes de acceso público.
        </p>
        <p>
          - Esta información, y la información combinada, podría ser usada para
          cualquiera de los usos y fines señalados en el presente documento.
          Para brindarte nuestros servicios y mejorar tu experiencia en nuestra
          página web y aplicación.
        </p>
        <p>
          - Para fines de funcionalidad y operatividad de la web y la
          aplicación.
        </p>
        <p>
          - Para poder brindarte soporte, resolver cualquier duda o consulta y
          resolver tus reclamos.
        </p>
        <p>
          - Para proteger tu seguridad y la de nuestra web y aplicación.
        </p>
        <p>
          - Para satisfacer un interés legítimo (que no anula nuestro deber de
          proteger tus datos personales) como la investigación y el desarrollo
          de nuestros servicios, promover el sitio web y proteger nuestros
          derechos e intereses legales.
        </p>
        <p>
          - Para procesar tus datos con el objeto de cumplir con una obligación
          legal.
        </p>
        <p>
          - Para procesar tus datos con el objeto de cumplir con una obligación
          contractual.
        </p>
        <p>
          <strong
            >NECESIDAD DE LA RECOLECCIÓN Y PROCESAMIENTO DE TUS DATOS</strong
          >
        </p>
        <p>
          EkeCash te informa que los datos personales y personales sensibles
          (recolectados incidentalmente) que te solicita, de conformidad con el
          presente Aviso de Privacidad, son necesarios y suficientes para que
          EkeCash realice un proceso de evaluación de riesgo de crédito y
          probabilidad de pago (scoring crediticio) en base a tu perfil y así
          poder determinar tu capacidad crediticia, lo cual es la base
          fundamental de la determinación de EkeCash para aprobar o rechazar el
          otorgamiento de tu solicitud de crédito y dar inicio a la relación
          jurídica contigo, así como para las demás finalidades primarias y
          secundarias que se señalan en el presente Aviso de Privacidad. Cabe
          resaltar que, la decisión final al respecto no es tomada de forma
          manual por un oficial o empleado de EkeCash, sino que, dicha decisión
          es tomada por los sistemas automatizados de EkeCash de conformidad con
          lo señalado en la sección “Decisiones Automatizadas” del presente
          Aviso de Privacidad.
        </p>
        <p>
          En ese sentido, para el caso de los prospectos de clientes el
          tratamiento de sus datos es necesario para analizar los perfiles y
          evaluar las solicitudes de crédito, mientras que para los clientes el
          tratamiento de sus datos es necesario para realizar la gestión
          contractual, validar la identidad, evaluar los riesgos crediticios y/o
          de cobranza y cumplir con la normativa vigente. En caso de no
          proporcionar los datos obligatorios no se podrá llevar a cabo las
          finalidades descritas en la presente Política.
        </p>
        <p>
          <strong>¿CÓMO OBTENEMOS Y ACTUALIZAMOS TUS DATOS?</strong>
        </p>
        <p>
          Los datos personales serán obtenidos y actualizados a través de:
        </p>
        <p>
          1. Ti, cuando bajas la aplicación de EkeCash y/o nos solicitas un
          préstamo;
        </p>
        <p>
          2. Tus otras interacciones con nosotros, incluyendo datos personales
          que voluntariamente compartes con nuestro departamento de atención al
          cliente o con nuestros empleados y agentes;
        </p>
        <p>
          3. Tu teléfono celular o dispositivo móvil cuando otorgas acceso y
          permisos que se describe abajo;
        </p>
        <p>
          4. Buros de crédito o agencias para prevenir el fraude;
        </p>
        <p>
          5. Cookies, web beacons y otros medios remotos de recolección
          automática de datos;
        </p>
        <p>
          6. Transmisores de dinero instituciones de fondos de pago electrónico,
          instituciones de financiamiento colectivo, instituciones de crédito y
          otras instituciones financieras y comercios electrónicos, con tu
          consentimiento, cuando sea necesario; y/o
        </p>
        <p>
          7. Terceros y otras fuentes públicas, con tu consentimiento, cuando
          sea necesario.
        </p>
        <p>
          <strong>¿PARA QUÉ USAMOS TUS DATOS?</strong>
        </p>
        <p>
          Las finalidades primarias (en lo sucesivo, las “Finalidades
          Primarias”) que dan origen y son necesarias para el mantenimiento y
          cumplimiento de la relación jurídica entre EkeCash y tú son las
          siguientes:
        </p>
        <p>
          - Verificar tu identidad, prevenir fraudes y cumplir con nuestras
          obligaciones de “conoce a tu cliente” bajo las leyes aplicables de
          prevención de lavado de dinero;
        </p>
        <p>
          - Crear tu perfil crediticio y asignarte una calificación crediticia
          para determinar si eres elegible para usar los productos y servicios
          de EkeCash;
        </p>
        <p>
          - Llevar a cabo la identificación y el conocimiento mediante
          recolección de datos personales, así como la integración de tu
          expediente que se mantendrá en la infraestructura tecnológica y
          sistemas de información de EkeCash y en otros archivos;
        </p>
        <p>
          - Incorporar los datos personales en instrumentos jurídicos, dar
          cumplimiento a los contratos que celebres con EkeCash, incluyendo,
          pero no limitado a ciertos contratos de usuario de nuestra aplicación
          y plataformas y los contratos de préstamo o crédito entre el Titular y
          EkeCash y administrar y manejar dichos contratos;
        </p>
        <p>
          - Originar, gestionar, dar servicio, mantener y exigir las deudas del
          Titular;
        </p>
        <p>
          - Brindarte servicios y gestionar tu cuenta con EkeCash y darte
          soporte como cliente;
        </p>
        <p>
          - Enviarte información de transacciones o notificaciones de
          transacciones, recordatorios de pago y anuncios a través de servicios
          de telefonía automáticos o mensajes pre-grabados, mensajes de texto o
          email;
        </p>
        <p>
          - Ceder o transmitir a un tercero, mediante cualquier medio, los
          derechos y/u obligaciones derivadas de los contratos antes señalados;
        </p>
        <p>
          - Utilizar los datos personales, en cualquier tipo de acto o
          diligencia de cobranza judicial o extrajudicial;
        </p>
        <p>
          - Cumplir con todas las leyes, reglamentos y disposiciones de carácter
          general aplicables;
        </p>
        <p>
          - Investigar cambios en tu perfil transaccional;
        </p>
        <p>- Prevención de fraudes;</p>
        <p>
          - Obtener datos personales para mejorar los modelos crediticios de
          EkeCash, sus modelos de datos y otros servicios; y
        </p>
        <p>
          - Analizar el comportamiento del cliente y mantener la calidad de
          nuestros servicios.
        </p>
        <p>
          Las finalidades secundarias (en lo sucesivo, las “Finalidades
          Secundarias”) que no son necesarias para el mantenimiento y
          cumplimiento de la relación jurídica entre EkeCash y tú, son las
          siguientes:
        </p>
        <p>
          - Envío de noticias, invitaciones a eventos de EkeCash.
        </p>
        <p>
          - Realización de encuestaconsers para mejorar nuestro servicio;
        </p>
        <p>
          - Uso de imágenes y testimonios que nos proporciones voluntariamente
          para fines publicitarios; y
        </p>
        <p>
          - La mercadotecnia, publicidad y/o promoción de los productos y/o
          servicios que sean ofrecidos por EkeCash al Titular, por cualquier
          medio material y/o electrónico. Con tu consentimiento al presente
          Aviso de Privacidad otorgas tu consentimiento expreso para que podamos
          contactarte con la finalidad de ofrecerte servicios financieros.
        </p>
        <p>
          Tu consentimiento es necesario para las finalidades secundarias. En
          ese sentido, tu consentimiento para el tratamiento de tus datos
          personales para las Finalidades Primarias no se encuentra sujeto a que
          nos brindes tu autorización para las Finalidades Secundarias, sino que
          debes autorizarnos de manera independiente para estas últimas a través
          del correo (servicio@ekecash.pe).
        </p>
        <p>
          <strong>¿CON QUIÉN COMPARTIMOS SUS DATOS?</strong>
        </p>

        <p>
          EkeCash tratará los datos personales y además podrá transferir
          internacionalmente únicamente a la Sociedad Receptora DOOWIN FINANCE
          LEASING CO., LTD, ubicada en China, con las siguientes finalidades:
        </p>
        <p>
          A. A DOOWIN FINANCE LEASING CO., LTD, como sociedad receptora ubicada
          en China, que opera bajo los mismos procesos y políticas internas, con
          la finalidad del acopio y tratamiento de datos personales; para hacer
          uso de servicios compartidos dentro del grupo de EkeCash y además
          para:
        </p>
        <p>
          i. Llevar a cabo la identificación y el conocimiento mediante
          recolección de datos personales del Titular, así como la integración
          de los datos personales en la infraestructura tecnológica de EkeCash,
          así como en sus sistemas de información y otros archivos;
        </p>
        <p>
          ii. Incorporar los datos personales del Titular en instrumentos
          jurídicos, dar cumplimiento a las obligaciones del Titular bajo los
          contratos celebrados entre el Titular y EkeCash, incluyendo de manera
          enunciativa, más no limitativa, ciertos contratos de usuario de
          nuestra aplicación y plataformas y los contratos de préstamo o crédito
          entre el Titular y EkeCash y administrar y manejar dichos contratos;
        </p>
        <p>
          iii. Ceder o transmitir, mediante cualquier medio, los derechos y/u
          obligaciones derivadas de los contratos antes señalados;
        </p>
        <p>
          iv. Utilizar los datos personales, en cualquier tipo de acto o
          diligencia de cobranza judicial o extrajudicial;
        </p>
        <p>
          Cumplir con todas las leyes, reglamentos y disposiciones de carácter
          general aplicables;
        </p>
        <p>
          vi. Prospectar y evaluar los datos personales para crear y asignar al
          titular una calificación crediticia o grado de calificación similar.
        </p>
        <p>
          vii. Obtener información para mejorar nuestro modelo crediticio, de
          datos y de servicios;
        </p>
        <p>
          viii. Investigar cambios en tu perfil transaccional;
        </p>
        <p>ix. Prevención de fraudes;</p>
        <p>
          x. Originar, gestionar, dar servicio, mantener y exigir la deuda del
          Titular.
        </p>
        <p>
          <strong
            >PUEDES NEGARTE O REVOCAR EL CONSENTIMIENTO PARA TRATAR TUS
            DATOS</strong
          >
        </p>
        <p>
          En caso de que desees revocar tu consentimiento o negarte al
          tratamiento de tus datos personales, con posterioridad a la firma y
          aceptación del presente Aviso, deberás enviar un correo electrónico a
          la dirección indicada en la sección anterior al Departamento de
          Protección de Datos Personales/Equipo de Atención al Cliente,
          servicio@ekecash.pe, siguiendo el procedimiento para la Negativa al
          Tratamiento y Revocación del Consentimiento que se describe en este
          Aviso.
        </p>
        <p>
          De acuerdo con lo anterior, el Departamento de Protección de Datos
          Personales/Equipo de Atención al Cliente es el encargado de atender
          todas las solicitudes de ejercicio de los derechos ARCO (acceso,
          rectificación, cancelación u oposición) mismo que puedes contactar en
          caso de cualquier duda o solicitud con respecto a tus datos personales
          a través del correo electrónico y teléfono antes indicados.
        </p>
        <p>
          <strong
            >¿QUÉ MEDIOS TIENES PARA LIMITAR EL USO Y DIVULGACIÓN DE DATOS
            PERSONALES?</strong
          >
        </p>
        <p>
          EkeCash ha creado un listado de exclusión para personas que no deseen
          recibir publicidad de EkeCash. Si recibes publicidad de EkeCash y no
          deseas seguir recibiéndola, podrás enviar un correo electrónico con tu
          nombre completo a servicio@ekecash.pe, solicitando tu eliminación de
          la lista de distribución con base en la cual se lleva a cabo el envío
          de la información o publicidad. En el mismo correo electrónico podrás
          solicitar más datos acerca de este listado.
        </p>
        <p>
          <strong
            >¿CUÁL ES EL PLAZO DURANTE EL CUAL SE CONSERVAN LOS DATOS
            BRINDADOS?</strong
          >
        </p>

        <p>
          En el caso de clientes: EkeCash conservará y realizará el tratamiento
          de los datos personales brindados de forma segura, durante la vigencia
          de la relación contractual con EkeCash. Una vez finalizada dicha
          relación contractual o la última interacción relevante, sus datos
          serán conservados por un plazo máximo de cinco (3) años, a menos que
          una normativa legal, fiscal o contable específica exija un plazo de
          conservación mayor.
        </p>
        <p>
          En el caso de prospecto de cliente: Los datos personales de aquellas
          personas que han proporcionado su información para una evaluación o
          potencial oferta de nuestros productos financieros (sin que se haya
          establecido una relación contractual) serán conservados por un plazo
          máximo de cinco (3) años desde su recopilación o la última interacción
          relevante. Esta conservación se realiza estrictamente para la
          finalidad de la evaluación de su perfil de riesgo crediticio y
          capacidad crediticia, o hasta que el titular de los datos revoque su
          consentimiento de forma expresa.
        </p>
        <p><strong>TUS DERECHOS ARCO</strong></p>
        <p>
          Tú, por ti mismo o mediante tu representante legal debidamente
          acreditado, puedes ejercer tus derechos de acceso, rectificación,
          cancelación u oposición al tratamiento de tus datos personales (los
          “Derechos ARCO”). Para ello podrás solicitar un formato de ejercicio
          de Derechos ARCO mediante el envío de un correo electrónico a la
          dirección servicio@ekecash.pe, en atención de Departamento de
          Protección de Datos Personales/Equipo de Atención al Cliente, al
          número telefónico +51 17017698 o bien a la dirección de EkeCash
          indicada en este Aviso con el nombre y los datos de contacto del
          Titular.
        </p>
        <p>
          El formato de ejercicio de Derechos ARCO se deberá llenar, firmar y
          presentarse acompañado de la siguiente documentación, a fin de que
          pueda llevarse a cabo la autenticación de usted:
        </p>
        <p>
          1. Tu identificación oficial vigente (Credencial del Instituto
          Nacional Electoral, Pasaporte, Cartilla del servicio Militar Nacional
          o Cédula Profesional).
        </p>
        <p>
          2. En los casos en que el ejercicio de los Derechos ARCO se realice a
          través de tu representante legal, deberá acompañarse la identificación
          oficial del representante, así como el poder correspondiente
          protocolizado que acredite la representación legal conferida por el
          Titular.
        </p>
        <p>
          3. Cuando se quiera ejercer el derecho de rectificación, deberá
          exhibirse la documentación que acredite el cambio solicitado de
          acuerdo a los datos personales a rectificar.
        </p>
        <p>
          EkeCash responderá a dicho formato dentro de los plazos establecidos
          en la Ley N° 29733, Ley de Protección de Datos Personales, y su
          Reglamento, aprobado por Decreto Supremo N° 003-2013-JUS. EkeCash le
          comunicará la resolución adoptada a través de las opciones elegidas
          por éste en el formato de ejercicio de Derechos ARCO.
        </p>
        <p>
          De considerar usted que no ha sido atendido en el ejercicio de sus
          derechos puede presentar una reclamación ante la Autoridad Nacional de
          Protección de Datos Personales, dirigiéndose a la Mesa de partes del
          Ministerio de Justicia y Derechos Humanos: Calle Scipion Llona 350,
          distrito de Miraflores, provincia y departamento de Lima.
        </p>
        <p>
          <strong>MODIFICACIONES A LA POLÍTICA DE PRIVACIDAD</strong>
        </p>
        <p>
          EkeCash se reserva el derecho de efectuar en cualquier momento cambios
          o modificaciones al presente Política de Privacidad, ante la necesidad
          de proporcionarle la protección continua y adecuada a sus datos
          personales, así como para la atención de novedades legislativas o
          jurisprudenciales, políticas internas, y prácticas del mercado. Los
          cambios y modificaciones estarán disponibles a través de los
          siguientes medios: anuncios en nuestras oficinas y en el portal web de
          EkeCash, a través de nuestro personal que recabe sus Datos Personales.
          Es aconsejable revisar el Política de Privacidad tras el enlace
          (https://www.ekecash.pe/notice) para ser enterado de cada modificación
          que habrá en el futuro. Si tienen cualquier duda sobre el Política de
          Privacidad, por favor no duden en ponerse en contacto con atención al
          cliente tras llamada (+51 17017698) o correo electrónico
          (servicio@ekecash.pe).
        </p>
        <p><strong>DECISIONES AUTOMATIZADAS</strong></p>
        <p>
          Tomamos algunas decisiones en relación con nuestros productos y
          servicios en forma automatizada sin intervención de una persona física
          en la valoración.
        </p>
        <p>
          <strong>I. Decisiones de otorgar préstamos</strong>
        </p>
        <p>
          Cuando solicitas un préstamo, usaremos un proceso automatizado para
          decidir si prestamos dinero y/o para toma de decisiones respecto a tu
          elegibilidad para nuestros productos o servicios.
        </p>
        <p>
          Nuestros procesos de revisión y otorgamiento de crédito utilizan
          inteligencia artificial para procesar tus datos personales y valorar
          tu capacidad crediticia. El tratamiento de tus datos personales es
          automatizado sin intervención o valoración humana. El uso de dichos
          procesos automatizados para verificar tu capacidad crediticia
          significa que podemos automáticamente decidir que no eres elegible
          para un préstamo o para un plazo o condiciones particulares. Nuestros
          modelos de suscripción y otorgamiento de crédito son probados
          regularmente para asegurarnos que son justos, exactos y sin
          prejuicios.
        </p>
        <p><strong>II. Detección de fraudes</strong></p>
        <p>
          EkeCash también utiliza procesos automatizados para detectar, combatir
          y prevenir fraudes. Nuestros modelos de detección de fraudes
          automáticamente deciden si una persona puede significar riesgo de
          fraude o lavado de dinero. Si nuestros modelos de detección de fraude
          al procesar una transacción o aprobar un crédito detectan riesgo, es
          posible que el acceso a la persona se rehuse.
        </p>
        <p><strong>III. Tus derechos</strong></p>
        <p>
          Si solicitas un crédito y eres rechazado basado en una decisión
          automatizada, tienes derecho a acceder a tu información y rectificarla
          contactándonos como se establece en la sección Derechos ARCO.
        </p>
        <p><strong>CONTACTO.</strong></p>
        <p>
          Si tiene alguna pregunta o sugerencia sobre esta política de
          privacidad, no dude en ponerse en contacto con nosotros.
        </p>
        <p>Nombre de producto: EKECASH</p>
        <p>Correo electrónico: servicio@ekecash.pe</p>
        <p>Número telefónico: +51 17017698</p>
        <p>
          Dirección: Golondrinas, 393, San Isidro, Lima, Perú
        </p>
        <p>
          Horario de trabajo: 9:00 a 19:00 horas de lunes a viernes
        </p>
      </div>
    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "@/components/oldFoot.vue";
import "../components/scss/Aviso.scss";

export default {
  name: "Aviso",
  components: { headNav, footPage },
  data() {
    return {};
  },
};
</script>

<style scoped>
.Aviso p {
  margin-bottom: 20px;
  color: #333;
}
.p-bottom {
  margin-bottom: 0 !important;
}
.title {
  font-size: 23px;
  margin-top: 15px;
  font-weight: 600;
}
.title_fontsmall {
  font-size: 18px !important;
  font-weight: 600;
}
</style>
